import { gql } from "@apollo/client";
export const CREATE_GROUP = gql`
  mutation CreateGroup(
    $name: String!
    $parent_group: String
    $child_scopes: [String]
    $child_groups: [String]
  ) {
    create_scope_group(
      name: $name
      parent_group: $parent_group
      child_scopes: $child_scopes
      child_groups: $child_groups
    ) {
      ok
      group_id
    }
  }
`;

export const EDIT_GROUP = gql`
  mutation EditGroup(
    $group_id: String!
    $name: String
    $parent_group: String
    $child_scopes: [String]
    $child_groups: [String]
    $overwrite: Boolean
  ) {
    edit_scope_group(
      group_id: $group_id
      name: $name
      parent_group: $parent_group
      child_scopes: $child_scopes
      child_groups: $child_groups
      overwrite: $overwrite
    ) {
      ok
      effected_queues
    }
  }
`;

export const GET_PARENT_GROUPS = gql`
  query GetParentGroups($group_id: String) {
    scope_groups(group_id: $group_id) {
      scope_groups
    }
  }
`;

export const GET_GROUP_BY_ID = gql`
  query GetGroupById($group_id: String!) {
    scope_group_by_id(group_id: $group_id) {
      group_data
    }
  }
`;

export interface ScopeGroupData {
  name?: string;
  parent_group?: { id?: string };
  child_groups?: Array<{ id: string }>;
  child_scopes?: Array<{ id: string }>;
}

// null when the payload is missing or not valid JSON.
export const parseGroupData = (
  raw: string | null | undefined
): ScopeGroupData | null => {
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw) as ScopeGroupData;
  } catch {
    return null;
  }
};
